import PropTypes from 'prop-types';

export default function OutlineClose(props) {
    const { color = 'currentColor', size = 20, strokeWidth = 1.5, ...rest } = props;

    return (
        <svg viewBox="0 0 20 20" fill="none" width={size} height={size} {...rest}>
            <path
                d="m4.344 4.343 11.313 11.314M4.344 15.657 15.657 4.343"
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={strokeWidth}
            />
        </svg>
    );
}

OutlineClose.propTypes = {
    color: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    className: PropTypes.string,
    strokeWidth: PropTypes.number,
};
